import api from './api';

export default async function deleteTestGroup(test_group_id) {
    const { data } = await api.delete(`test_groups/${test_group_id}`);
    return data;
}